import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnvelope = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	fill: "none",
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M4.8 6.4a3.2 3.2 0 0 0-3.2 3.2v1.858l13.505 6.753a2 2 0 0 0 1.79 0L30.4 11.458V9.6a3.2 3.2 0 0 0-3.2-3.2z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m30.4 14.142-12.432 6.216a4.4 4.4 0 0 1-3.936 0L1.6 14.142V22.4a3.2 3.2 0 0 0 3.2 3.2h22.4a3.2 3.2 0 0 0 3.2-3.2z"
	})]
});
export default SvgEnvelope;
